<script>
import { getRelation } from '@/pages/planbkChart/components/common.js'

export default {
  name: 'FamilyTableView',
  props: {
    tableData: {
      type: Array,
      default () {
        return []
      }
    },
    isShowBusinessCard: {
      type: Boolean,
      default: false
    },
    cardImageData: {
      type: String,
      default: ''
    }
  },
  computed: {
    fmTotalBaof () {
      const { tableData } = this
      if (!Array.isArray(tableData)) return 0
      return tableData.reduce((previous, current) => {
        previous += parseFloat(current.totalBaof)
        return previous
      }, 0)
    }
  },
  methods: {
    getRelation (value, sex) {
      return getRelation(value, sex)
    }
  }
}
</script>
<template>
  <div id="my-node" class="family_table" @click="$emit('view')">
    <div class="table-title">
      <h2>专属定制的保障方案</h2>
    </div>
    <table v-if="tableData.length" class="table-layout">
      <thead>
        <tr>
          <th>被保人</th>
          <th>投保人</th>
          <th>产品名称</th>
          <th>保额</th>
          <th>保险期</th>
          <th>交费期</th>
          <th>首年保费</th>
          <th>保障责任</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(mbData, mIndex) in tableData">
          <template v-for="(planbook, pbIndex) in mbData.list">
            <tr
              v-for="(product, pIndex) in planbook.tableList"
              :key="`${mIndex}-${pbIndex}-${pIndex}`"
            >
              <template v-if="!pbIndex && !pIndex">
                <td class="table-bg" :rowspan="mbData.totalCount">
                  <p>
                    {{ mbData.name || getRelation(mbData.type, mbData.sex) }}
                  </p>
                  {{ planbook.insuredInfo.sexDesc }}
                  {{ planbook.insuredInfo.age }}岁
                </td>
                <td :rowspan="mbData.totalCount">
                  <p>
                    {{
                      planbook.activeName ||
                        getRelation(planbook.type, planbook.sex)
                    }}
                  </p>
                  {{ planbook.applicantInfo.sexDesc }}
                  {{ planbook.applicantInfo.age }}岁
                </td>
              </template>
              <td>{{ product.titleName }}</td>
              <td>{{ product.baoeDp }}</td>
              <td>{{ product.iDurationDesc }}</td>
              <td>{{ product.pPeriodDesc }}</td>
              <td>{{ product.totalBaof }}</td>
              <td>
                <div
                  v-for="(item, idx) in product.liability"
                  :key="idx"
                  class="description1"
                  v-html="item.parsedDesc1"
                />
              </td>
            </tr>
          </template>
        </template>
      </tbody>
      <tbody>
        <tr>
          <td colspan="6">
            总计
          </td>
          <td>{{ fmTotalBaof }}</td>
          <td />
        </tr>
      </tbody>
    </table>
    <div v-if="isShowBusinessCard" class="card_image_wrap">
      <img :src="cardImageData" alt="">
    </div>
  </div>
</template>
<style lang="postcss" scoped>
@import './table.css';
.table-layout {
  thead {
    th {
      &:first-child {
        width: 10%;
      }
      &:nth-child(2) {
        width: 10%;
      }
      &:nth-child(3) {
        width: 17.5%;
      }
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        width: 7.5%;
      }
      &:nth-child(7) {
        width: 10%;
      }
    }
  }
  tbody {
    tr:nth-child(2n + 1) {
      td:last-child,
      td:nth-last-child(2),
      td:nth-last-child(3),
      td:nth-last-child(4),
      td:nth-last-child(5),
      td:nth-last-child(6) {
        background-color: #f8f8f8;
      }
    }
    td:nth-last-child(2),
    td:nth-last-child(5) {
      color: #ff5000;
    }
    tr:last-child {
      td {
        &:nth-last-child(2) {
          color: #ff5000;
        }
      }
    }
    &:last-child {
      td {
        background-color: #f8f8f8;
      }
    }
  }
}
</style>